/**
 * Адрес витрины DataHunter.
 *
 * Отдельным модулем от `dh-seo.ts`, хотя это одна строка. Причина в
 * зависимостях: `dh-seo` тянет навигацию next-intl, а её нельзя поднять
 * в юнит-тесте — модуль обращается к `next/navigation`, которого вне
 * приложения не существует. Разметка бренда (`components/seo/schema`)
 * из-за этого оказывалась непроверяемой, хотя сама по себе не знает о
 * маршрутизации ничего.
 *
 * Значение читается из окружения на сборке: на стенде домен другой.
 */
export const DH_SITE_URL = process.env.NEXT_PUBLIC_DATAHUNTER_URL ?? 'https://datahunter.store';
